import PricingTab from './PricingTab';
export default PricingTab;
